<aw-dialog
  (onClose)="dialogRef.close($event)"
  [content]="content"
  [footer]="footer"
  [width]="width"
  [data]="data"
  [title]="data.headline">
  <ng-template #content>
    <div class="flex flex-col gap-2">
      <aw-text-input
        id="operator-mapping-name"
        [label]="cmsTextProvider.configuration.onDemandJourneyProvider"
        [formControl]="data.operatorMapping.controls.name"></aw-text-input>
      <aw-text-input
        id="operator-mapping-operator-id"
        [label]="cmsTextProvider.configuration.operatorId"
        [formControl]="
          data.operatorMapping.controls.operatorId
        "></aw-text-input>
      <aw-text-input
        id="operator-mapping-url"
        [label]="cmsTextProvider.configuration.url"
        [formControl]="data.operatorMapping.controls.url"></aw-text-input>

      <!-- Sorte für Bedarfsverkehrsprodukt -->
      <aw-drop-down
        id="operator-mapping-on-demand-sort"
        [label]="cmsTextProvider.configuration.onDemandSortLabel"
        [formControl]="data.operatorMapping.controls.onDemandSortExternalRef"
        [options]="sorts()"
        name="name"
        valueAttribute="externalReference"
        [isLoading]="sortsLoading()"
        [showResetIcon]="true" />

      <!-- Sorte für Komfortzuschlag -->
      <aw-drop-down
        id="operator-mapping-comfort-sort"
        [label]="cmsTextProvider.configuration.comfortSortLabel"
        [formControl]="data.operatorMapping.controls.comfortSortExternalRef"
        [options]="sorts()"
        name="name"
        valueAttribute="externalReference"
        [isLoading]="sortsLoading()"
        [showResetIcon]="true" />

      <!-- Produktgruppe für ÖPNV-Teil -->
      <aw-drop-down
        id="operator-mapping-product-group"
        [label]="cmsTextProvider.configuration.publicTransportProductGroupLabel"
        [formControl]="
          data.operatorMapping.controls.publicTransportProductGroup
        "
        [options]="sortGroups()"
        name="name"
        valueAttribute="name"
        [isLoading]="sortGroupsLoading()"
        [showResetIcon]="true" />

      <!-- Dropdown-Optionen -->
      <div class="flex flex-col gap-2">
        <div class="pb-2 font-semibold">
          {{ cmsTextProvider.configuration.dropDownOptions }}
        </div>
        <aw-button
          id="operator-drop-down-option-create"
          type="button"
          (click)="addDropDownOption()">
          <span class="material-symbols-rounded pr-2">add</span>
          {{ cmsTextProvider.configuration.addDropDownOption }}
        </aw-button>
        @for (
          option of data.operatorMapping.controls.dropDownOptions.controls;
          track $index
        ) {
          <div class="flex flex-row items-center gap-2">
            <aw-text-input
              [id]="'operator-mapping-option-' + $index"
              [label]="cmsTextProvider.configuration.dropDownOptionName"
              [formControl]="option.controls.name"></aw-text-input>
            <span
              class="material-symbols-rounded text-input-error cursor-pointer"
              (click)="removeDropDownOption($index)"
              [id]="'operator-mapping-option' + $index + 'delete'">
              delete
            </span>
          </div>
        }
      </div>
    </div>
  </ng-template>
  <ng-template #footer>
    <aw-button
      [id]="'confirm'"
      [type]="'button'"
      [isDisabled]="!data.operatorMapping.valid"
      (click)="dialogRef.close({ submit: true, data, acceptChanges: false })"
      [text]="cmsTextProvider.shared.save"
      class="mr-3 w-full" />
    <aw-button
      class="w-full"
      [id]="'cancel'"
      [type]="'button'"
      (click)="dialogRef.close()"
      [style]="'primary-alt'"
      [text]="cmsTextProvider.shared.cancel" />
  </ng-template>
</aw-dialog>
